import { render, staticRenderFns } from "./Opstalvallei.vue?vue&type=template&id=658bec75&"
import script from "./Opstalvallei.vue?vue&type=script&lang=ts&"
export * from "./Opstalvallei.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports